import { render, staticRenderFns } from "./MainView.vue?vue&type=template&id=5ccff6ef&scoped=true&"
import script from "./MainView.vue?vue&type=script&lang=js&"
export * from "./MainView.vue?vue&type=script&lang=js&"
import style0 from "./MainView.vue?vue&type=style&index=0&id=5ccff6ef&scoped=true&lang=css&"
import style1 from "./MainView.vue?vue&type=style&index=1&id=5ccff6ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccff6ef",
  null
  
)

export default component.exports